export enum Position {
    Top = "Top",
    Bottom = "Bottom",
    Left = "Left",
    Right = "Right"
}
